import React, { useState, useEffect } from 'react';
import axios from '../helpers/axiosConfig';
import { useNavigate } from 'react-router-dom';

const MinistreSuccessifsList = () => {
  const [ministres, setMinistres] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('/ministresuccessifs');
        setMinistres(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <p className="container mt-5">Chargement...</p>;
  if (error) return <p className="container mt-5">Erreur : {error}</p>;

  return (
    <div className="container mt-5">
      <table className="table table-striped">
        <thead className="thead-dark">
          <tr>
            <th>N°</th>
            <th>Nom et Prénoms</th>
            <th>Catégorie</th>
            <th>du</th>
            <th>au</th>
            <th>Actions</th>
          </tr>
        </thead>
        {ministres.map((ministre, key) => (
          <tr key={ministre.id}>
            <td>{ministre.id}</td>
            <td>{ministre.nomprenom}</td>
            <td>{ministre.categorie}</td>
            <td>{ministre.du}</td>
            <td>{ministre.au || 'à ce jour'}</td>
            <td>
              <i style={{ cursor: 'pointer' }} className="fa fa-eye mr-2" onClick={() => navigate(`/personnel/${ministre.personnel.id}`)}></i>
              <i style={{ cursor: 'pointer' }} className="fa fa-pencil p-2 mr-2" onClick={() => navigate(`/ministresuccessifs/edit/${ministre.id}/x`)}></i>
            </td>
          </tr>
        ))}
      </table>
    </div>
  );
};

export default MinistreSuccessifsList;
